import { useId, useState } from "react";
import { RnCheckmark } from "@remi/icons/next";
import { RemiAlert, RemiCollapsible, RemiCollapsibleContent, RemiOTP, useEffect } from "@remi/next-ui";

type OtpFormProps = {
  onSubmit: (otp: string) => void;
  resetError: () => void;
  handleResend: () => void;
  otp: string;
  setOtp: (otp: string) => void;
  label?: string;
  showAlert?: boolean;
  alertText?: string;
  showResend?: boolean;
};
export const OtpForm = ({
  onSubmit,
  resetError,
  otp,
  setOtp,
  handleResend,
  label = "Enter your verification code",
  showAlert = true,
  alertText = "We've sent you a link to your email",
  showResend = true,
}: OtpFormProps) => {
  const [countdown, setCountdown] = useState(15);
  const labelId = useId();
  useEffect(() => {
    if (countdown > 0) {
      const timer = setTimeout(() => {
        setCountdown(countdown - 1);
      }, 1000);
      return () => clearTimeout(timer);
    }
    return undefined;
  });

  const onChange = (newOtp: string) => {
    resetError();
    setOtp(newOtp);
    if (newOtp.length === 6) {
      onSubmit(newOtp);
    }
  };
  return (
    <div className="space-y-4">
      <span id={labelId}>{label}</span>
      <RemiOTP value={otp} onChange={onChange} aria-labelledby={labelId}></RemiOTP>
      {showResend && (
        <div className="font-medium text-text-secondary text-xs">
          Didn&apos;t receive a code?
          <button
            className="ml-1 text-text-accent disabled:opacity-50"
            onClick={() => {
              setCountdown(15);
              handleResend();
            }}
            disabled={countdown > 0}
            type="button"
          >
            Resend {countdown > 0 && `(${countdown}s)`}
          </button>
        </div>
      )}
      <RemiCollapsible open={showAlert && countdown >= 10}>
        <RemiCollapsibleContent>
          <RemiAlert
            variant="secondary"
            hasButtons={false}
            icon={<RnCheckmark size="sm" />}
            centerContent={true}
            className="mt-8 mb-2 items-center border-border-success bg-background-successLight text-text-success"
          >
            <span className="font-medium text-xs">{alertText}</span>
          </RemiAlert>
        </RemiCollapsibleContent>
      </RemiCollapsible>
    </div>
  );
};
